<template>
    <v-card>
        <v-card-title class="primary white--text">
            <span class="headline">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
            <v-container>
                <v-form
                    ref="form"
                    lazy-validation
                >
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-select
                                :items="eventFor"
                                label="Who is the event for?"
                                v-model="newEventFor"
                                :rules="requiredRules"
                            ></v-select>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="12" md="4" v-if="newEventFor === 'Client'">
                            <v-autocomplete
                                v-model="newEvent"
                                :items="clientEvents"
                                item-text="Name"
                                item-value="_id"
                                label="Event"
                                @change="visit()"
                            ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="12" md="4" v-if="newEventFor === 'Staff'">
                            <v-autocomplete
                                v-model="newEvent"
                                :items="staffEvents"
                                item-text="Name"
                                item-value="_id"
                                label="Event"
                            ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="12" md="4"
                               v-if="newEventFor === 'Client' || newEventFor === 'Staff'">
                            <v-select
                                v-model="newClient"
                                :items="clients"
                                item-text="Name"
                                item-value="_id"
                                label="Client"
                                :rules="requiredRules"
                                @change="getProviders"
                            ></v-select>
                        </v-col>
                        <template v-if="drsVisit">
                            <v-col cols="12" sm="12" md="6">
                                <v-select
                                    v-model="newReviewingProvider"
                                    label="Providers"
                                    :items="providers"
                                    item-text="Provider.Name"
                                    item-value="Provider._id"
                                    :rules="requiredRules"
                                ></v-select>
                            </v-col>
                            <!-- <v-col  cols="12" sm="12" md="6">
                              <v-select
                                v-model="newProviderType"
                                label="Providers"
                                :items="providers"
                                item-text="Name"
                                item-value="_id"
                                :rules="requiredRules"
                              ></v-select>
                            </v-col> -->
                            <v-col cols="12" sm="12" md="6">
                                <v-select
                                    v-model="newVisitType"
                                    label="Visit Type"
                                    :items="visitTypes"
                                    item-value="Name"
                                    item-text="Name"
                                    :rules="requiredRules"
                                ></v-select>
                            </v-col>
                        </template>
                        <v-col class="d-flex" cols="12" sm="12" md="4">
                            <v-autocomplete
                                v-model="newStaff"
                                :items="users"
                                item-text="Name"
                                item-value="_id"
                                label="Staff Assigned"
                                clearable
                                :rules="requiredRules"
                                return-object
                                :filter="customFilter"
                            >
                                <template #selection="{ item }">
                                    <v-chip :key="item._id" v-if="item">{{ item.Name }}</v-chip>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="12" md="4">
                            <v-select
                                v-model="newProgram"
                                :items="selectedClientPrograms"
                                label="Program"
                                :rules="requiredRules"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-datetime-picker
                                label="Start Date"
                                v-model="newDate"
                                time-format="hh:mm a"
                                date-format="MM/dd/yyyy"
                                :rules="[v => !!v || 'Required']"
                            ></v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-datetime-picker
                                label="End Date"
                                v-model="newEndDate"
                                time-format="hh:mm a"
                                date-format="MM/dd/yyyy"
                                :rules="requiredRules"
                            ></v-datetime-picker>
                        </v-col>

                        <v-col cols="12" sm="12">
                            <v-textarea
                                v-model="newNotes"
                                outlined
                                label="Notes of Event"
                                value=""
                            ></v-textarea>
                        </v-col>

                        <v-container fluid>
                            <p>Recurring Events?</p>
                            <v-radio-group v-model="isRecurringEvent" mandatory>
                                <v-radio label="Yes" value="Yes"></v-radio>
                                <v-radio label="No" value="No"></v-radio>
                            </v-radio-group>
                        </v-container>
                        <v-col cols="12" sm="12" md="6" v-if="isRecurringEvent === 'Yes'">
                            <v-select
                                :items="optionsForRecurring"
                                label="More"
                                v-model="selectedOption"
                                outlined
                            ></v-select>
                        </v-col>

                        <v-col cols="12" sm="12" md="4" v-if="newEventFor === 'Client'">
                            <span>Is Transportation Required?</span>
                            <v-switch label="Yes" value="Yes" v-model="newTransportation"></v-switch>
                            <v-switch label="No" value="No" v-model="newTransportation"></v-switch>
                        </v-col>
                        <v-col v-if="newTransportation === 'Yes'" cols="12" sm="12" md="4">
                            <v-text-field
                                label="Transportation From"
                                v-model="newFrom"
                            ></v-text-field>
                        </v-col>
                        <v-col v-if="newTransportation === 'Yes'" cols="12" sm="12" md="4">
                            <v-text-field
                                label="Transportation To"
                                v-model="newTo"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12">
                            <v-text-field
                                readonly
                                v-model="DateCreated"
                                label="Date Created"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-text-field
                                readonly
                                v-model="CreatedBy"
                                label="Created By"
                            ></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" sm="12">

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn label="Completed By Signature" v-model="Signed" @click="getSignature()" v-on="on" v-bind="attrs">Completed</v-btn>
                              </template>
                              <span>Sign only after the appointment has been attended and completetd.	</span>
                            </v-tooltip>

                            <v-text-field v-if="Signed == true" v-model="Signature"></v-text-field>

                        </v-col> -->
                    </v-row>
                </v-form>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                class="blue darken-2 white--text"
                :loading="addCalEvent_btn_loader"
                :disabled="addCalEvent_btn_loader"
                @click="addCalendarEvent()"
            >
                Save & Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>

        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    import moment from "moment";
    import {mapActions} from "vuex";

    const url = require("../../client_config/config").url;

    export default {
        props: {
            getEvents: Function,
            close: Function,
            titleForm: String,
            programs: Array,
            clients: Array,
            users: Array,
            clientEvents: Array,
            staffEvents: Array,
            visitTypes: Array,
        },
        data: () => ({
            msg: "",
            text: "",
            color: "success",
            newStaffEvent: "",
            newStaff: "",
            newEventFor: "",
            newEvent: "",
            newClient: "",
            newProgram: "",
            newDate: "",
            newEndDate: "",
            newNotes: "",
            newLocation: "",
            newTransportation: "",
            newFrom: "",
            newTo: "",
            CreatedBy: localStorage.getItem('Name'),
            DateCreated: new Date(),
            Signature: "",
            Signed: false,
            UserSigned: "",
            units: [],
            newUnit: "",
            textFieldProps: {
                appendIcon: "event"
            },
            startDateProps: {
                min: moment(new Date()).format("YYYY-MM-DD")
            },
            startTimeProps: {
                ampmInTitle: true
            },
            requiredRules: [v => !!v || 'This is required'],
            drsVisit: false,
            newVisitType: "",
            newReviewingProvider: "",
            recurring: "",
            yesno: ["Yes", "No"],
            duration: ["Annually", "Monthly", "Weekly", "Every other Week"],
            newDuration: "",
            monthly: ["Last Day of the Month",
                "First Day of the Week"],
            weekly: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            eventFor: ["Staff", "Client"],
            selectedClientPrograms: [],
            search: '',
            providers: [],
            addCalEvent_btn_loader: false,
            isRecurringEvent: "No",
            optionsForRecurring: ['Daily', 'Weekly', 'Monthly', 'Annually'],
            selectedOption: "",

        }),
        watch: {},

        created() {
        },

        methods: {
            ...mapActions({
                getClientProviders: "clientProviders/getItem",
            }),

            async getProviders(clientId){
                const response = await this.getClientProviders(clientId);
                this.providers = response.data;
                this.setProgram(clientId);
            },


            addCalendarEvent: async function () {
                this.addCalEvent_btn_loader = true;

                let validate = this.$refs.form.validate();
                let payload = {};

                if (!validate) {
                    this.msg = true;
                    this.text = "Please fill all required fields.";
                    this.color = "success";
                    this.addCalEvent_btn_loader = false;
                    return false;
                }

                if (!this.newDate) {
                    alert('Please input start date.');
                    this.addCalEvent_btn_loader = false;
                    return;
                }

                if (!this.newEndDate) {
                    alert('Please input End date.');
                    this.addCalEvent_btn_loader = false;
                    return;
                }

                if (this.newEventFor === "Client") {
                    payload = {
                        Event: this.newEvent,
                        EventFor: this.newEventFor,
                        Client: this.newClient,
                        Staff: this.newStaff,
                        Program: this.newProgram,
                        StartDate: this.newDate,
                        EndDate: this.newEndDate,
                        Notes: this.newNotes,
                        Transportation: this.newTransportation,
                        From: this.newFrom,
                        To: this.newTo,
                        CreatedBy: localStorage.getItem('Name'),
                        DateCreated: this.DateCreated,
                        Signature: this.Signature,
                        ReviewingProvider: this.newReviewingProvider,
                        VisitType: this.newVisitType,
                        UrlNotification: this.$router.history.current.path,
                        isRecurringEvent: this.isRecurringEvent,
                        typeOfRecurringEvent: this.selectedOption,
                    };
                } else if (this.newEventFor === "Staff") {
                    payload = {
                        Event: this.newEvent,
                        EventFor: this.newEventFor,
                        Staff: this.newStaff,
                        Client: this.newClient,
                        Program: this.newProgram,
                        StartDate: this.newDate,
                        EndDate: this.newEndDate,
                        Notes: this.newNotes,
                        Transportation: this.newTransportation,
                        From: this.newFrom,
                        To: this.newTo,
                        CreatedBy: localStorage.getItem('Name'),
                        DateCreated: this.DateCreated,
                        Signature: this.Signature,
                        ReviewingProvider: this.newReviewingProvider,
                        VisitType: this.newVisitType,
                        UrlNotification: this.$router.history.current.path,
                        isRecurringEvent: this.isRecurringEvent,
                        typeOfRecurringEvent: this.selectedOption,
                    };
                }

                await axios.post(`${url}/calendar`, payload).then(res => {
                    if (res) {
                        this.msg = true;
                        this.text = "The event has been added successfully.";
                        this.color = "success";
                        this.newEventFor = "";
                        this.newEvent = "";
                        this.newClient = "";
                        this.newStaff = "";
                        this.newProgram = "";
                        this.newDate = "";
                        this.newEndDate = "";
                        this.newNotes = "";
                        this.newTransportation = "";
                        this.newFrom = "";
                        this.newTo = "";
                        this.newCreatedBy = "";
                        this.Signature = "";
                        this.newReviewingProvider = "";
                        this.selectedOption = "";

                        let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: false};
                        this.$emit('addCalendarEvent', emitValue);
                        this.getEvents();
                    }
                })
                .catch(async err => {
                    if (err.response) {
                        this.text = await err.response.data.msg;
                        this.msg = true;
                        this.color = "error";
                        let emitValue = {msg: this.msg, text: this.text, color: this.color, addDialog: true};
                        this.$emit('addCalendarEvent', emitValue);
                    }
                }).finally(() => this.addCalEvent_btn_loader = false);

            },

            setProgram(clientId) {
                const client = this.clients.find(client => client._id === clientId);

                if (client && client.Program && client.Program.length) {
                    this.selectedClientPrograms = client.Program;
                    this.newProgram = client.Program[0];
                }
            },


            visit() {
                this.drsVisit = this.newEvent === "Dr. Visit";
            },


            customFilter(item, queryText) {
                const searchText = queryText.toLowerCase();
                const itemName = item.Name.toLowerCase();
                return itemName.indexOf(searchText) > -1;
            },

            searchProvider(){
                if (!this.search) {
                    this.providers = this.clientProviders
                }

                this.providers = this.clientProviders.filter((item) => {
                    return item.Provider.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                });
            }

        }
    };
</script>
